<template>
  <div class="todaybtn" :class="{'active': active}">
    {{ $t("hoje") }}
  </div>
</template>
<script>
export default {
  name: "todaybutton",
  props:["active"]
}
</script>
<style scoped>
  .todaybtn{
    border: 2px solid #1976d2;
    font-family: "Montserrat Semibold";
    font-size: 14px;
    border-radius: 45px;
    width: 80px;
    height: 40px;
    text-align: center;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: #1976d2;
  }
  .todaybtn.active{
    background-color: #1976d2;
    color: white;
  }

  .todaybtn:hover{
    background-color: #1976d2;
    color: white;
    cursor: pointer;
  }
</style>